module.exports = __webpack_public_path__ + "static/media/fotogalereya5.dfe50a27.jpg";